/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */
import React, { Component } from 'react';
import map from 'lodash/map';
import find from 'lodash/find';
import sortBy from 'lodash/sortBy';
import reverse from 'lodash/reverse';
import mapKeys from 'lodash/mapKeys';

import {
  Dropdown,
  Segment,
  Divider,
  Grid,
  Container,
  Loader,
  Checkbox,
  Button,
  Accordion,
  Icon,
  Tab,
  Menu,
  Modal,
  TextArea,
  Popup
} from 'semantic-ui-react';
import DayPicker from 'react-day-picker';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import moment from 'moment';
import 'react-day-picker/lib/style.css';

import AdPreview from '../../components/common/AdPreview';
import { updateUrl } from '../../utils/urls';
import months from '../../utils/months';
import { getAd, getAds, getTargetingSentencelines } from '../../fbApi/Ad';
import getPages from '../../fbApi/User';
import { publishPost, schedulePost, getPost } from '../../fbApi/Post';
import { clearFbCacheInLocalStorage } from '../../fbApi/fbCallManager';
import { fillHours } from '../../utils/dates';
import {
  dateStyle,
  cellStyle,
  cellStyleSmall,
  getHalfCell,
  getFullCell,
  getFullCellSmall,
  dateStyleSmall,
  getHalfCellSmall,
  cellPostsSmall,
  cellPosts
} from './CalendarComponents';
import OrganicPreviewList from './OrganicPreviewList';
import { getAccounts, refreshAccounts } from '../../services/AccountService';
import { getCampaigns, getCampaign } from '../../fbApi/Campaign';
import {
  getCategoryByName,
  getActiveTabs,
  tabColors
} from './OrganicAdSorting';
import {
  buildAdPreviewObjectCompare,
  renderHoldAd,
  getColorRow,
  checkAdProductSet,
  getPreviews
} from '../../utils/ad.common';
import { retrieveAllAdsInfo } from '../../services/AdServiceManager';

import './OrganicSimplifier.css';

class OrganicSimplifier extends Component {
  state = {
    adTabActiveIndex: [],
    expandAll: false,
    accordionIndex: {
      COLLECTION: -1,
      CANVAS: -1,
      CAROUSEL: -1,
      CINEMA: -1,
      STILL: -1,
      VIDEO: -1,
      HOLIDAY: -1,
      LEASE: -1,
      OTHER: -1
    },
    data: null,
    showMonthSelector: false,
    showYearSelector: false,
    adAccountName: null,
    accounts: null,
    showMonthLoader: false,
    showYearLoader: false,
    doneLoading: false,
    paging: null,
    summary: null,
    accountOptions: null,
    adAccountId: null,
    selectedYear: '',
    selectedMonth: '',
    selectedAccounts: [],
    selectedCampaigns: '',
    campaignMonth: {
      COLLECTION: [],
      CANVAS: [],
      CAROUSEL: [],
      CINEMA: [],
      STILL: [],
      VIDEO: [],
      HOLIDAY: [],
      LEASE: [],
      OTHER: []
    },
    campaigns: [],
    years: [],
    previews: [],
    presentation: {
      url: null,
      data: {}
    },
    campaignList: {
      COLLECTION: 'Collection',
      CANVAS: 'Canvas',
      CAROUSEL: 'Carousel',
      CINEMA: 'Cinema',
      STILL: 'Still',
      VIDEO: 'Video',
      HOLIDAY: 'Holiday',
      LEASE: 'Lease',
      OTHER: 'Other',
      ORGANIC: 'Organic'
    },
    adStatus: [],
    organicList: [],
    activeTabName: '',
    log: '',
    processing: false,
    processingText: '',
    activeIndex: 0,
    showModal: false,
    showCalendar: false,
    token: this.props.getFbToken(),
    calendarCurrentMonth: null,
    pages: {},
    refreshAccountsLoading: false,
    loadingAccounts: false
  };

  componentDidMount() {
    this.initialize();
  }

  initialize = () => {
    const { setSectionTitle, saveGTMEvent } = this.props;
    setSectionTitle('Organic Scheduler');
    saveGTMEvent('Organic Scheduler', 'Organic Scheduler');
    this.setState(
      (prevState) => ({
        ...prevState,
        hours: fillHours(),
        loadingAccounts: true
      }),
      async () => {
        const { token } = this.state;
        const pages = await getPages(token, true, this.props.user.groups[0]);
        const { data } = pages || {};
        this.setState(
          (prevState) => ({
            ...prevState,
            pages: data && data.length > 0 ? pages : { data: [] }
          }),
          async () => {
            await this.getAdAccounts();
            await this.preSelectFields();
          }
        );
      }
    );
  };

  getAdAccounts = async () => {
    try {
      const result = await getAccounts(this.props.user.groups[0]);

      const accountOptions = sortBy(
        map(result, (op, index) => ({
          key: index,
          value: op.account_id,
          text: op.name
        })),
        'text'
      );

      this.setState({
        data: result,
        accounts: sortBy([...result], 'name'),
        accountOptions,
        loadingAccounts: false
      });
    } catch (error) {
      console.log('Error in getAdAccounts(): ', error);
    }
  };

  refreshAccounts = () => {
    this.setState(
      (...prevState) => ({
        ...prevState,
        refreshAccountsLoading: true
      }),
      async () => {
        const { token } = this.state;
        const pages = await getPages(token, true, this.props.user.groups[0]);
        this.setState(
          (...prevState) => ({
            ...prevState,
            pages
          }),
          async () => {
            clearFbCacheInLocalStorage();
            await this.refreshAdAccounts();
            await this.preSelectFields();
            this.setState((...prevState) => ({
              ...prevState,
              refreshAccountsLoading: false
            }));
          }
        );
      }
    );
  };

  refreshAdAccounts = async () => {
    try {
      const result = await refreshAccounts(this.props.user.groups[0]);

      const accountOptions = sortBy(
        map(result, (op, index) => ({
          key: index,
          value: op.account_id,
          text: op.name
        })),
        'text'
      );

      this.setState({
        data: result,
        accounts: sortBy([...result], 'name'),
        accountOptions
      });
    } catch (error) {
      console.log('Error in refreshAdAccounts(): ', error);
    }
  };

  getCampaigns = async (id) => {
    try {
      this.setState({ campaigns: null });
      this.setState({ previews: null });
      this.setState({ showYearLoader: true });
      this.setState({ campaigns: [] });
      this.setState({ previews: [] });

      const screen = 'Organic Scheduler';
      const campaigns = await getCampaigns(id, this.state.token, screen);
      const result = campaigns.data;

      const assocCampaigns = [];
      const campaignMonths = [];
      const years = [];

      map(reverse(sortBy([...result], 'start_time')), (campaign) => {
        const firstPart = campaign.name.split('_')[0];
        const year =
          firstPart.length === 4
            ? firstPart
            : firstPart.substring(firstPart.length - 4, firstPart.length);
        const month =
          firstPart.length === 4
            ? campaign.name.split('_')[1]
            : firstPart.substring(0, firstPart.length - 4);
        assocCampaigns[year + month] = {
          month_year: null,
          ids: []
        };
      });

      map(reverse(sortBy([...result], 'start_time')), (campaign) => {
        const firstPart = campaign.name.split('_')[0];
        const year =
          firstPart.length === 4
            ? firstPart
            : firstPart.substring(firstPart.length - 4, firstPart.length);
        const month =
          firstPart.length === 4
            ? campaign.name.split('_')[1]
            : firstPart.substring(0, firstPart.length - 4);

        const existentYear = years.filter((item) => item.text === year);

        if (existentYear.length === 0) {
          years.push({
            value: year,
            text: year
          });
        }

        assocCampaigns[year + month].month = month;
        assocCampaigns[year + month].year = year;
        assocCampaigns[year + month].ids.push(campaign.id);
      });

      mapKeys(assocCampaigns, (assocCampaign) => {
        if (assocCampaign) {
          campaignMonths.push(assocCampaign);
        }
      });

      const campaignOpts = map(campaignMonths, (op, index) => {
        const month = months.filter((item) => item.shortName === op.month);

        return {
          key: index,
          value: op.ids.join(','),
          text: month[0] ? month[0].monthName : op.month,
          accountId: id,
          year: op.year
        };
      });

      this.setState({
        data: result,
        campaigns: campaignOpts,
        filteredCampaigns: campaignOpts,
        showYearSelector: true,
        showYearLoader: false,
        years
      });
      return campaignOpts;
    } catch (error) {
      console.log(error);
    }
  };

  getPostForAd = async (ad, pages) => {
    try {
      const postId = ad.creative.effective_object_story_id;
      const pageId = postId.split('_')[0];
      const page = pages.data.find((item) => item.id === pageId);
      const post = await getPost(postId, page.access_token);
      return post;
    } catch (e) {
      return undefined;
    }
  };

  getAds = async (ids) => {
    this.resetState();
    await this.setState({ showAdsLoading: true });
    const { token, selectedYear, selectedMonth, pages } = this.state;
    const adStatus = {};
    const allIds = [];
    const allCampaigns = await Promise.all(
      map(ids, async (id) => {
        const campaign = await getCampaign(id, token);
        const resultAds = await getAds(campaign.id, token);
        const ads = resultAds.data;
        const campaignObjective = campaign.objective;

        const previewObjects = ads.map(async (ad) => {
          allIds.push(ad.id);
          if (ad.name.indexOf('Retargeting') === -1) {
            const post = await this.getPostForAd(ad, pages);
            adStatus[ad.id] = {
              ad: {
                adId: ad.id,
                ad_name: ad.name,
                campaignObjective: ad.campaign.objective
              },
              showAdCalendar: false,
              errorMessage: '',
              selectedDate: new Date(selectedYear, selectedMonth - 1, 1),
              selectedHour: '12:30pm',
              convertedDate: '',
              selectedHourName: '12:30 pm',
              post
            };
          }
          return {
            ...ad,
            ad_id: ad.id,
            name: ad.name,
            ad_name: ad.name,
            campaignObjective
          };
        });

        return Promise.all(previewObjects);
      })
    );

    const ccm = {
      COLLECTION: [],
      CANVAS: [],
      CAROUSEL: [],
      CINEMA: [],
      STILL: [],
      VIDEO: [],
      HOLIDAY: [],
      LEASE: [],
      OTHER: [],
      ORGANIC: []
    };

    map(allCampaigns, (campaignAds) => {
      map(campaignAds, (ad) => {
        if (
          ad.campaignObjective !== 'PRODUCT_CATALOG_SALES' &&
          ad.ad_name.indexOf('Retargeting') === -1
        ) {
          ccm[getCategoryByName(ad)].push(ad);
        }
      });
    });

    const allAdsInfo = await retrieveAllAdsInfo(allIds.join(','));

    const campMonth = await this.processCampaigns(ccm, allAdsInfo);
    const cleanedCampMonth = await this.removeDynamicAdsFromCampaignMonth(
      campMonth
    );
    this.setState({
      doneLoading: true,
      showAdsLoading: false,
      campaignMonth: cleanedCampMonth,
      adStatus
    });
  };

  renderMobileAd = (preview) => (
    <AdPreview
      title="Mobile Ad Preview"
      maxWidthDiv={320}
      maxHeight={620}
      offsetVertical={900}
      iframe_url={preview.mobile_iframe_url}
    />
  );

  renderDesktopAd = (preview) => (
    <AdPreview
      title="Desktop Ad Preview"
      maxWidthDiv={720}
      maxHeight={762}
      offsetVertical={1500}
      iframe_url={preview.desktop_iframe_url}
    />
  );

  getTabIndex = (preview) => {
    const previewId = preview.ad_id;
    const currItem = this.state.adTabActiveIndex.filter(
      (ad) => ad.id === previewId
    )[0];

    if (currItem) {
      return currItem.tabIndex;
    }

    const tabIndex = typeof preview.ad_title !== 'string' ? 1 : 0;
    this.state.adTabActiveIndex.push({
      id: previewId,
      tabIndex,
      defaultTabIndex: tabIndex
    });
    return tabIndex;
  };

  renderAdTabs = (adTabs, preview) => {
    const previewId = preview.ad_id;
    const adActiveIndex = adTabs.length === 1 ? 0 : this.getTabIndex(preview);
    return (
      <Tab
        panes={adTabs}
        activeIndex={adActiveIndex}
        onTabChange={(e, { activeIndex }) => {
          this.handleTabChange(activeIndex, previewId);
        }}
      />
    );
  };

  getShortAdName = (adSetName) => {
    const splitName = adSetName.split('_');
    splitName.splice(0, 1);
    splitName.splice(0, 1);
    splitName.splice(0, 1);
    return splitName.join(' ');
  };

  showEdit = (adId) => {
    const { organicList } = this.state;
    const organic = organicList.find((item) => item.adId === adId);

    return organic && organic.scheduled !== 'Publish';
  };

  setDate = (adId) => {
    const { adStatus } = this.state;
    adStatus[adId].showAdCalendar = !adStatus[adId].showAdCalendar;
    adStatus[adId].errorMessage = '';
    this.setState({ adStatus });
  };

  selectDate = (adId, day) => {
    const { adStatus } = this.state;
    adStatus[adId].selectedDate = day;
    this.setState({ adStatus });
  };

  onHourSelect = (event, data) => {
    const { adStatus } = this.state;
    const hour = data.options.find((item) => item.value === data.value);
    adStatus[data.id].selectedHourName = hour.text;
    adStatus[data.id].selectedHour = data.value;
    this.setState({ adStatus });
  };

  showCancel = (adId) => {
    const { organicList } = this.state;

    const existAd = organicList.find((organic) => organic.adId === adId);
    return existAd;
  };

  openPost = (e, data) => {
    window.open(e.target.id, '_blank');
    e.stopPropagation();
  };

  renderNewPosts = (day, readOnly) => {
    const { organicList } = this.state;
    const date = day.getDate();
    const currentMonth = day.getMonth() + 1;

    return organicList.map((ad) => {
      if (ad.date) {
        const postDate = ad.date;
        const postDay = postDate.getDate();
        const postMonth = postDate.getMonth() + 1;

        if (postDay === date && postMonth === currentMonth) {
          const tabs = this.state.campaignList;
          const tab = Object.values(tabs).find((item) => item === ad.adType);
          const indexTab = Object.values(tabs).indexOf(tab);

          const category = Object.keys(tabs)[indexTab];
          const color = tabColors[category];
          const accountWithoutSpace = this.state.selectedAccounts[0].name
            .split(' ')
            .join('');
          const adName = ad.adName
            .replace(this.state.selectedAccounts[0].name, '')
            .replace(accountWithoutSpace, '');

          return (
            <Popup
              wide="very"
              style={{ 'background-color': color }}
              basic
              trigger={
                <a
                  onClick={(e) =>
                    this.openAccordion(ad.index, ad.adType, ad.adId, e)
                  }
                >
                  <div
                    style={
                      !readOnly ? getHalfCell(color) : getHalfCellSmall(color)
                    }
                  />
                </a>
              }
              content={<p>{`${ad.adType.toUpperCase()}: ${adName}`}</p>}
            />
          );
        }
      }
    });
  };

  renderExistentPosts = (day, readOnly) => {
    const { adStatus } = this.state;
    const date = day.getDate();
    const currentMonth = day.getMonth() + 1;

    return Object.values(adStatus).map((ad) => {
      if (
        ad.post &&
        (ad.post.scheduled_publish_time ||
          (ad.post.is_published && ad.post.created_time))
      ) {
        const postDate = ad.post.scheduled_publish_time
          ? new Date(ad.post.scheduled_publish_time * 1000)
          : new Date(ad.post.created_time);
        const postDay = postDate.getDate();
        const postMonth = postDate.getMonth() + 1;

        if (postDay === date && postMonth === currentMonth) {
          const category = getCategoryByName(ad.ad);
          const sortedAds = sortBy(
            [...this.state.campaignMonth[category]],
            'adset_name'
          );
          const originalAd = sortedAds.find(
            (item) => item.ad_id === ad.ad.adId
          );
          const indexAd = sortedAds.indexOf(originalAd);
          const color = tabColors[category];

          const adName = this.getShortAdName(ad.ad.ad_name);

          return (
            <Popup
              wide="very"
              style={{ backgroundColor: color }}
              basic
              trigger={
                <a
                  onClick={(e) =>
                    this.openAccordion(
                      indexAd,
                      this.state.campaignList[category],
                      ad.ad.adId,
                      e
                    )
                  }
                >
                  <div
                    style={
                      !readOnly ? getFullCell(color) : getFullCellSmall(color)
                    }
                  />
                </a>
              }
              content={
                <p>{`${this.state.campaignList[
                  category
                ].toUpperCase()}: ${adName.trim() || ad.ad.ad_name}`}</p>
              }
            />
          );
        }
      }
      return null;
    });
  };

  renderDay = (day, readOnly) => {
    const date = day.getDate();

    return (
      <div style={!readOnly ? cellStyle : cellStyleSmall}>
        <div style={!readOnly ? dateStyle : dateStyleSmall}>{date}</div>
        <div style={!readOnly ? cellPosts : cellPostsSmall}>
          {this.renderNewPosts(day, readOnly)}
          {this.renderExistentPosts(day, readOnly)}
        </div>
      </div>
    );
  };

  renderContent = (preview, index, campaignKey) => {
    const {
      accordionIndex,
      adStatus,
      expandAll,
      showCalendar,
      calendarCurrentMonth,
      hours
    } = this.state;
    const adTabs = this.getTabAds(preview);
    const post = adStatus[preview.ad_id].post;
    return (
      <Accordion.Content
        active={accordionIndex[campaignKey] === index || expandAll}
      >
        <div
          key={index}
          className="header-container generic-content campaign-tabs"
        >
          {showCalendar ? (
            <Modal
              dimmer={'inverted'}
              open={showCalendar}
              onClose={this.onCloseCalendar}
              className="modal-calendar"
            >
              <Modal.Header>Calendar</Modal.Header>
              <Modal.Content>
                <DayPicker
                  onDayClick={(day) => this.selectDate(preview.ad_id, day)}
                  canChangeMonth={false}
                  month={calendarCurrentMonth}
                  renderDay={(day) => this.renderDay(day, false)}
                />
              </Modal.Content>
            </Modal>
          ) : null}
          <Segment basic style={{ padding: 0 }}>
            <div
              className={
                this.showCancel(preview.ad_id)
                  ? 'error-message-cancel'
                  : 'error-message'
              }
            >
              {adStatus[preview.ad_id].errorMessage}
            </div>
            <div className="scheduler-button-container">
              {this.showCancel(preview.ad_id) ? (
                <Button
                  color="orange"
                  onClick={() => this.cancel(preview.ad_id)}
                >
                  Cancel
                </Button>
              ) : null}
              <Button
                disabled={
                  post && (post.is_published || post.scheduled_publish_time)
                }
                color="pink"
                onClick={() => this.publish(preview, index)}
              >
                Publish
              </Button>
              <Button
                color="green"
                disabled={
                  post && (post.is_published || post.scheduled_publish_time)
                }
                onClick={() => this.setDate(preview.ad_id)}
              >
                {this.showEdit(preview.ad_id) ? 'Edit Date' : 'Set Date'}
              </Button>
              {adStatus[preview.ad_id].showAdCalendar ? (
                <div className="date-selector">
                  <Icon
                    name="calendar"
                    className={
                      this.showCancel(preview.ad_id)
                        ? this.showEdit(preview.ad_id)
                          ? 'calendar-icon-position-edit'
                          : 'calendar-icon-position-cancel'
                        : 'calendar-icon-position'
                    }
                    size="big"
                  />
                  <DayPickerInput
                    onDayChange={(day) => this.selectDate(preview.ad_id, day)}
                    value={adStatus[preview.ad_id].selectedDate}
                    defaultValue={calendarCurrentMonth}
                  />
                  <Dropdown
                    placeholder="Time"
                    search
                    selection
                    id={preview.ad_id}
                    className="time-selector"
                    defaultValue={'12:30pm'}
                    value={adStatus[preview.ad_id].selectedHour}
                    options={hours}
                    onChange={this.onHourSelect}
                  />
                  <Button
                    color="green"
                    className="schedule-button"
                    onClick={() => this.schedule(preview, index)}
                  >
                    Schedule
                  </Button>
                </div>
              ) : null}
            </div>
            <Divider hidden />
            {this.renderAdTabs(adTabs, preview)}
          </Segment>
        </div>
      </Accordion.Content>
    );
  };

  renderStatusIcon = (adStatus) => {
    let statusIcon = <i className="circle icon black" />;
    switch (adStatus) {
      case 'ACTIVE':
        statusIcon = <i className="circle icon green" />;
        break;
      case 'DISAPPROVED':
        statusIcon = <i className="circle icon red" />;
        break;
      default:
        statusIcon = <i className="circle icon black" />;
        break;
    }
    return statusIcon;
  };

  renderTitles = (preview, index, campaignKey) => {
    const { accordionIndex, expandAll, adStatus } = this.state;
    const {
      ad_id: adId,
      ad_status: previewAdStatus,
      ad_name: adName
    } = preview;
    const { post } = adStatus[adId] || {};
    const {
      scheduled_publish_time: scheduledPublishTime,
      is_published: isPublished,
      permalink_url: permaLinkUrl
    } = post || {};
    let scheduleDate = '';

    if (post && scheduledPublishTime) {
      const date = new Date(scheduledPublishTime * 1000);
      scheduleDate = `${
        date.toISOString().split('T')[0]
      } ${date.getHours()}:${date.getMinutes()}`;
    }
    const colorRow = getColorRow(preview);

    return (
      <div>
        <Accordion.Title
          style={{ background: colorRow, color: colorRow ? 'white' : null }}
          active={accordionIndex[campaignKey] === index || expandAll}
          index={index}
          onClick={() => this.handleAccordionClick(index, campaignKey)}
        >
          <Grid>
            <Grid.Row>
              <Grid.Column width={13}>
                <Icon name="dropdown" />
                {this.renderStatusIcon(previewAdStatus)}
                {adName}
                {post && isPublished ? (
                  <div className="published-text">
                    This ad has already been posted. Click
                    <a onClick={this.openPost} id={permaLinkUrl}>
                      {' '}
                      here{' '}
                    </a>{' '}
                    to view
                  </div>
                ) : null}
                {post && scheduledPublishTime ? (
                  <div className="published-text">
                    {' '}
                    SCHEDULED at {scheduleDate}
                  </div>
                ) : null}
              </Grid.Column>
              <Grid.Column width={3} textAlign="right">
                {renderHoldAd(preview)}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Accordion.Title>
        {this.renderContent(preview, index, campaignKey)}
      </div>
    );
  };

  renderPreviews = (previews, campaignKey) => {
    return (
      <Accordion fluid styled>
        {previews.map((preview, index) =>
          this.renderTitles(preview, index, campaignKey)
        )}
      </Accordion>
    );
  };

  renderCampaignsTabs(campaignMonth) {
    const renderMenuItemTab = (campaignKey) => (
      <Menu.Item
        style={{ 'background-color': tabColors[campaignKey] }}
        key={campaignKey}
      >
        {this.state.campaignList[campaignKey]}
      </Menu.Item>
    );

    const tabs = Object.keys(this.state.campaignList)
      .filter((key) => {
        if (campaignMonth[key]) return campaignMonth[key].length > 0;
      })
      .map((key, index) => ({
        menuItem: renderMenuItemTab(key, campaignMonth),
        render: () => (
          <Tab.Pane>{this.renderPreviews(campaignMonth[key], key)}</Tab.Pane>
        )
      }));

    return (
      <Tab
        defaultActiveIndex="0"
        activeIndex={this.state.activeIndex}
        onTabChange={(key) => this.getTabName(key)}
        panes={tabs}
      />
    );
  }

  getTabName = (key) => {
    const activeTabs = getActiveTabs(this.state.campaignMonth);
    const tabs = this.state.campaignList;
    const tab = Object.values(tabs).find((item) => item === key.target.text);
    const indexTab = Object.values(activeTabs).indexOf(tab);
    this.setState({ activeTabName: key.target.text, activeIndex: indexTab });
  };

  processCampaigns = async (ccm, allAdsInfo) => {
    await Promise.all(
      map(Object.keys(ccm), async (k) => {
        const newList = await this.processAdsAsync(ccm[k], allAdsInfo.ads);
        // eslint-disable-next-line no-param-reassign
        ccm[k] = newList;
        Promise.resolve();
      })
    );
    return ccm;
  };

  processAdsAsync = async (adList, allAdsInfo) => {
    const { token } = this.state;
    const buildedAds = await Promise.all(
      map(adList, async (ad) => {
        const adData = allAdsInfo
          ? allAdsInfo.find((a) => a.adId === ad.id)
          : undefined;
        const buildAd = {
          ...ad,
          adData: adData ? adData.adData : undefined
        };
        const adPreview = await buildAdPreviewObjectCompare(buildAd, '', token);
        return Promise.resolve(adPreview);
      })
    );

    return buildedAds;
  };

  getTabAds = (preview) => {
    let onlyMobile;
    if (preview.desktop_iframe_url) {
      onlyMobile = preview.desktop_iframe_url.indexOf('mobile-only') >= 0;
    }
    const desktopAd = {
      menuItem: { key: 'Desktop', icon: <Icon size="large" name="desktop" /> },
      render: () => <Tab.Pane>{this.renderDesktopAd(preview)}</Tab.Pane>
    };

    const mobileAd = {
      menuItem: { key: 'Mobile', icon: <Icon size="big" name="mobile" /> },
      render: () => <Tab.Pane>{this.renderMobileAd(preview)}</Tab.Pane>
    };

    if (onlyMobile) {
      return [mobileAd];
    }
    return [mobileAd, desktopAd];
  };

  schedule = async (ad, index) => {
    const adStatus = this.state.adStatus;

    if (!(await this.validDate(ad))) {
      adStatus[ad.ad_id].errorMessage =
        'The schedule date must be between 10 minutes and 6 months from the current date';
      this.setState({ adStatus });
      return;
    }

    const organicList = this.state.organicList;
    adStatus[ad.ad_id].showAdCalendar = false;
    adStatus[ad.ad_id].errorMessage = '';

    const existAd = organicList.find((organic) => organic.adId === ad.ad_id);
    if (existAd) {
      existAd.scheduled = `${
        adStatus[ad.ad_id].convertedDate.toISOString().split('T')[0]
      } ${adStatus[ad.ad_id].selectedHourName}`;
      existAd.date = adStatus[ad.ad_id].convertedDate;
      this.setState({ organicList, adStatus });
      return;
    }

    adStatus[ad.ad_id].errorMessage = '';
    const adType = this.state.campaignList[getCategoryByName(ad)];
    const scheduledDate = `${
      adStatus[ad.ad_id].convertedDate.toISOString().split('T')[0]
    } ${adStatus[ad.ad_id].selectedHourName}`;
    organicList.push({
      adType,
      adId: ad.ad_id,
      scheduled: scheduledDate,
      adName: ad.ad_name,
      date: adStatus[ad.ad_id].convertedDate,
      index
    });
    this.setState({ organicList, adStatus });
  };

  validDate = async (ad) => {
    const adStatus = this.state.adStatus;
    if (!adStatus[ad.ad_id].selectedHour || !adStatus[ad.ad_id].selectedDate) {
      return false;
    }

    let hour = adStatus[ad.ad_id].selectedHour.replace('am', '');
    hour = hour.replace('pm', '');
    const hourParts = hour.split(':');
    const date = adStatus[ad.ad_id].selectedDate;

    date.setHours(hourParts[0]);
    date.setMinutes(hourParts[1]);
    const startDate = new Date();
    const endDate = new Date();
    startDate.setMinutes(startDate.getMinutes() + 10);
    endDate.setMonth(endDate.getMonth() + 6);
    adStatus[ad.ad_id].convertedDate = date;
    await this.setState({ adStatus });

    return date >= startDate && date <= endDate;
  };

  cancel = (adId) => {
    const { adStatus, organicList } = this.state;
    adStatus[adId].selectedDate = new Date(
      this.state.selectedYear,
      this.state.selectedMonth - 1,
      1
    );
    adStatus[adId].selectedHour = '12:30pm';
    adStatus[adId].selectedHourName = '12:30 pm';
    adStatus[adId].showAdCalendar = false;

    const organic = organicList.find((item) => item.adId === adId);
    const index = organicList.indexOf(organic);

    organicList.splice(index, 1);
    this.setState({ organicList });
  };

  publish = (ad, index) => {
    const organicList = this.state.organicList;
    const adStatus = this.state.adStatus;
    adStatus[ad.ad_id].showAdCalendar = false;
    adStatus[ad.ad_id].errorMessage = '';
    adStatus[ad.ad_id].selectedDate = new Date(
      this.state.selectedYear,
      this.state.selectedMonth - 1,
      1
    );
    adStatus[ad.ad_id].selectedHour = '12:30pm';
    adStatus[ad.ad_id].selectedHourName = '12:30 pm';

    const existAd = organicList.find((organic) => organic.adId === ad.ad_id);
    if (existAd) {
      // eslint-disable-next-line no-shadow
      const index = organicList.indexOf(existAd);
      existAd.scheduled = 'Publish';
      existAd.date = null;
      this.setState({ organicList, adStatus });
      return;
    }

    const adType = this.state.campaignList[getCategoryByName(ad)];
    organicList.push({
      adType,
      adId: ad.ad_id,
      scheduled: 'Publish',
      adName: ad.ad_name || ad.name,
      index
    });
    this.setState({ organicList, adStatus });
  };

  resetState = async () => {
    await this.setState({
      previews: [],
      doneLoading: false,
      adStatus: [],
      organicList: [],
      activeTabName: '',
      log: '',
      campaignMonth: {
        COLLECTION: [],
        CANVAS: [],
        CAROUSEL: [],
        CINEMA: [],
        STILL: [],
        VIDEO: [],
        HOLIDAY: [],
        LEASE: [],
        OTHER: []
      },
      accordionIndex: {
        COLLECTION: -1,
        CANVAS: -1,
        CAROUSEL: -1,
        CINEMA: -1,
        STILL: -1,
        VIDEO: -1,
        HOLIDAY: -1,
        LEASE: -1,
        OTHER: -1
      },
      activeIndex: 0,
      showModal: false
    });
  };

  handleAccordionClick = async (index, campaignKey) => {
    const { accordionIndex, campaignMonth, token } = this.state;
    const adAtIndex = campaignMonth[campaignKey]
      ? campaignMonth[campaignKey][index]
      : {};

    if (adAtIndex.ad_id) {
      const {
        ad_id: adId,
        ad_name: adName,
        ad_link: adLink,
        campaignObjective
      } = adAtIndex;
      const adObject = {
        id: adId,
        name: adName,
        campaign: {
          objective: campaignObjective
        }
      };

      const isCanvas = adLink ? adLink.split('canvas_doc').length > 1 : false;

      const preview = await getPreviews(
        adObject,
        token,
        isCanvas,
        adName.split('Collection').length > 1
      );
      adAtIndex.desktop_iframe_url = preview.desktop;
      adAtIndex.mobile_iframe_url = preview.mobile;
    }

    if (accordionIndex[campaignKey] === index) {
      accordionIndex[campaignKey] = -1;
    } else {
      accordionIndex[campaignKey] = index;
    }

    this.setState((prevState) => ({ ...prevState, accordionIndex }));
  };

  selectAccount = async (accountId, accountName) => {
    this.setState({
      selectedAccounts: [
        ...this.state.selectedAccounts,
        { value: accountId, name: accountName }
      ],
      selectedYear: '',
      adAccountId: accountId,
      adAccountName: accountName,
      doneLoading: false,
      showMonthSelector: false,
      showAdsLoading: false,
      showDropdownLoading: false,
      campaignMonth: {
        COLLECTION: [],
        CANVAS: [],
        CAROUSEL: [],
        CINEMA: [],
        STILL: [],
        VIDEO: [],
        HOLIDAY: [],
        LEASE: [],
        OTHER: []
      },
      campaigns: []
    });

    const getCampaignsRes = await this.getCampaigns(accountId);

    return getCampaignsRes;
  };

  onAccountSelect = async (event, data) => {
    const n = find(data.options, (o) => o.value === data.value);

    const accountId = n.value;
    const accountName = n.text;
    updateUrl(accountName, '', '');
    await this.selectAccount(accountId, accountName);
  };

  selectYear = (value) => {
    const filteredCampaigns = this.state.campaigns.filter(
      (val) => val.year === value
    );

    this.setState({
      showMonthSelector: true,
      showMonthLoader: false,
      filteredCampaigns,
      selectedCampaigns: '',
      selectedYear: value,
      doneLoading: false,
      showAdsLoading: false,
      showDropdownLoading: false
    });

    this.resetState();
  };

  onYearSelect = (event, data) => {
    const value = data.value;
    updateUrl(this.state.adAccountName, value, '');
    this.selectYear(value);
  };

  selectMonth = (ids, monthYear) => {
    const accountId = this.state.selectedAccounts[0].value;
    const month = months.find((item) => item.monthName === monthYear);
    const selectedMonth =
      month && month.monthNumber
        ? month.monthNumber
        : new Date().getMonth() + 1;
    const calendarCurrentMonth = new Date(
      this.state.selectedYear,
      selectedMonth - 1
    );
    this.setState({
      selectedMonth,
      campaign_ids: [{ value: ids, text: monthYear, accountId }],
      adTabActiveIndex: [],
      selectedCampaigns: ids.join(','),
      accordionIndex: {
        COLLECTION: -1,
        CANVAS: -1,
        CAROUSEL: -1,
        CINEMA: -1,
        STILL: -1,
        VIDEO: -1,
        HOLIDAY: -1,
        LEASE: -1,
        OTHER: -1
      },
      calendarCurrentMonth,
      calendarSelectedMonth: selectedMonth
    });

    this.getAds(ids);
  };

  onMonthSelect = (event, data) => {
    const n = find(data.options, (o) => o.value === data.value);
    const ids = n.value.split(',');
    const monthYear = n.text;
    updateUrl(this.state.adAccountName, this.state.selectedYear, monthYear);
    this.selectMonth(ids, monthYear);
  };

  onCalendarMonthSelect = (event, data) => {
    const calendarCurrentMonth = new Date(
      this.state.selectedYear,
      data.value - 1
    );
    this.setState({ calendarCurrentMonth });
  };

  handleExpandAll = () => {
    this.setState({ expandAll: !this.state.expandAll });
  };

  handleTabChange = (activeIndex, previewId) => {
    const arr = this.state.adTabActiveIndex.map((item) => {
      if (item.id === previewId) {
        return {
          id: previewId,
          tabIndex: activeIndex,
          defaultTabIndex: item.defaultTabIndex
        };
      }
      return item;
    });
    this.setState({ adTabActiveIndex: arr });
  };

  fillHours = () => {
    this.setState({ hours: fillHours() });
  };

  preSelectFields = async () => {
    const url = window.location.href;
    const urlParts = url.split('#');

    if (!urlParts[1]) {
      return;
    }

    const params = urlParts[1].split('&');
    const selectedAccount = find(
      params,
      (p) => p && p.indexOf('account=') !== -1
    );

    if (selectedAccount) {
      const accountValue = selectedAccount
        .split('=')[1]
        .replace(new RegExp('%20', 'g'), ' ');
      if (!accountValue) return;
      const account = find(
        this.state.accounts,
        (a) => a.name && a.name.indexOf(accountValue) !== -1
      );

      if (account) {
        const campaigns = await this.selectAccount(
          account.account_id,
          account.name
        );
        const selectedYear = find(
          params,
          (p) => p && p.indexOf('year=') !== -1
        );

        if (selectedYear) {
          const yearValue = selectedYear
            .split('=')[1]
            .replace(new RegExp('%20', 'g'), ' ');
          if (!yearValue) return;
          this.selectYear(yearValue);
          const selectedMonth = find(
            params,
            (p) => p && p.indexOf('month=') !== -1
          );

          if (selectedMonth) {
            const monthValue = selectedMonth
              .split('=')[1]
              .replace(new RegExp('%20', 'g'), ' ');
            if (!monthValue) return;
            const month = find(
              campaigns,
              (c) => c.text && c.text.indexOf(monthValue) !== -1
            );
            const ids = month.value.split(',');
            this.selectMonth(ids, month.text);
          }
        }
      }
    }
  };

  schedulePost = async (
    postId,
    convertedDate,
    selectedHourName,
    pageToken,
    item
  ) => {
    const timestamp = Math.round(convertedDate.getTime() / 1000);

    const data = {
      id: postId,
      timestamp
    };

    const result = await schedulePost(data, pageToken);

    if (result.error) {
      this.setState({
        log: `${this.state.log + item.adName} - ${result.error.message}\n\n`
      });
    } else {
      this.setState({
        log: `${this.state.log +
          item.adName}' - The post has been scheduled to be published at ${
          convertedDate.toISOString().split('T')[0]
        }' '${selectedHourName}\n\n`
      });
    }

    return result;
  };

  publishPost = async (postId, pageToken, item) => {
    const data = {
      id: postId
    };

    const result = await publishPost(data, pageToken);

    if (result.error) {
      this.setState({
        log: `${this.state.log + item.adName}' - '${result.error.message}\n\n`
      });
    } else {
      this.setState({
        log: `${this.state.log +
          item.adName}' - The post has been published\n\n'`
      });
    }

    return result;
  };

  schedulePosts = () => {
    if (!this.state.organicList || this.state.organicList.length === 0) {
      this.setState({
        log: '',
        processingText: 'You must select ads to schedule'
      });
    } else {
      this.setState(
        {
          log: '',
          processing: true,
          processingText: 'Scheduling Ads...'
        },
        async () => {
          const { getFbToken, user } = this.props;
          const token = getFbToken();
          const pages = await getPages(token, true, user.groups[0]);
          const { error, data: pageData } = pages || {};
          if (error || !pageData) {
            this.setState({
              log: `${this.state.log}Error requesting the pages\n`,
              processing: false,
              processingText: 'Could not schedule ads'
            });
          } else {
            await Promise.all(
              this.state.organicList.map(async (item) => {
                const ad = await getAd(item.adId, token);
                const postId = ad.creative.effective_object_story_id;
                const pageId = postId.split('_')[0];
                const page = pages.data.find(
                  (pageItem) => pageItem.id === pageId
                );

                if (!page) {
                  this.setState({
                    log: `${this.state.log}' The page does not belong to the user\n'`,
                    processing: false,
                    processingText: 'Could not schedule ads'
                  });
                  return Promise.resolve({});
                }
                let result = null;
                if (item.scheduled === 'Publish') {
                  result = await this.publishPost(
                    postId,
                    page.access_token,
                    item
                  );
                } else {
                  const convertedDate = this.state.adStatus[item.adId]
                    .convertedDate;
                  const selectedHourName = this.state.adStatus[item.adId]
                    .selectedHourName;
                  result = await this.schedulePost(
                    postId,
                    convertedDate,
                    selectedHourName,
                    page.access_token,
                    item
                  );
                }

                return Promise.resolve(result);
              })
            );

            this.setState({
              processing: false,
              processingText: '',
              showModal: true
            });
          }
        }
      );
    }
  };

  openAccordion = (index, type, adId, e) => {
    if (e) {
      e.stopPropagation();
    }

    this.onCloseCalendar();
    const activeTabs = getActiveTabs(this.state.campaignMonth);
    const tabs = this.state.campaignList;
    const indexTab = Object.values(activeTabs).indexOf(type);
    const tabName = Object.keys(tabs)[Object.values(tabs).indexOf(type)];
    const accordionIndex = this.state.accordionIndex;
    accordionIndex[tabName] = index;
    this.setState({ accordionIndex, activeIndex: indexTab }, () => {
      try {
        this[`focusAd${adId}`].focus();
      } catch (error) {
        console.log('error in openAccordion:', error);
      }
    });
  };

  onCloseModal = () => {
    this.setState({ showModal: false }, async () => {
      await this.getAds(this.state.campaign_ids[0].value);
    });
  };

  showLog = () => {
    this.setState({ showModal: true });
  };

  showCalendar = () => {
    this.setState({ showCalendar: true });
  };

  onCloseCalendar = () => {
    this.setState({ showCalendar: false });
  };

  prevMonth = () => {
    const calendarCurrentMonth = moment(this.state.calendarCurrentMonth);
    calendarCurrentMonth.add('month', -1);

    this.setState({
      calendarCurrentMonth: calendarCurrentMonth.toDate(),
      calendarSelectedMonth: calendarCurrentMonth.month() + 1
    });
  };

  nextMonth = () => {
    const calendarCurrentMonth = moment(this.state.calendarCurrentMonth);
    calendarCurrentMonth.add('month', 1);

    this.setState({
      calendarCurrentMonth: calendarCurrentMonth.toDate(),
      calendarSelectedMonth: calendarCurrentMonth.month() + 1
    });
  };

  currentMonth = () => {
    const { selectedYear, selectedMonth } = this.state;
    const calendarCurrentMonth = new Date(selectedYear, selectedMonth - 1);

    this.setState({
      calendarCurrentMonth,
      calendarSelectedMonth: selectedMonth
    });
  };

  removeDynamicAdsFromCampaignMonth = async (campaignMonth) => {
    const { campaignList } = this.state;
    const adTypeKeys = Object.keys(campaignList);
    const newCampaignMonth = {};
    const adTypeGroups = await Promise.all(
      adTypeKeys.map(async (key) => {
        const previews = campaignMonth[key];
        const sortedNonDynamicPreviews = await this.removeDynamicAds(
          previews,
          key
        );
        const { length } = sortedNonDynamicPreviews;
        if (length > 0) {
          return { key, sortedNonDynamicPreviews };
        }
        return {
          key,
          sortedNonDynamicPreviews: []
        };
      })
    );
    adTypeGroups.forEach((group) => {
      const { key, sortedNonDynamicPreviews } = group;
      newCampaignMonth[key] = sortedNonDynamicPreviews;
    });

    return newCampaignMonth;
  };

  removeDynamicAds = async (previews, campaignKey) => {
    const { token } = this.state;
    const sortedPreviews = sortBy([...previews], 'adset_name');
    let newSortedPreviews = [];
    if (campaignKey === 'COLLECTION' || campaignKey === 'CAROUSEL') {
      newSortedPreviews = await Promise.all(
        sortedPreviews.map(async (preview) => {
          const { facebookInfo } = preview;
          const { creativeId } = facebookInfo;
          const productSetId = await checkAdProductSet(creativeId, token);
          if (!productSetId) {
            return preview;
          }
          return null;
        })
      );
      const filteredNewSortedPreviews = newSortedPreviews.filter(
        (preview) => preview !== null
      );
      return filteredNewSortedPreviews;
    }
    return sortedPreviews;
  };

  render() {
    const {
      accountOptions,
      years,
      filteredCampaigns,
      campaignMonth,
      log,
      calendarCurrentMonth,
      refreshAccountsLoading,
      loadingAccounts
    } = this.state;

    const calendarMonth = months.map((m) => ({
      key: m.monthNumber,
      text: m.monthName,
      value: m.monthNumber
    }));
    return (
      <div className="container">
        <Modal
          dimmer={'inverted'}
          open={this.state.showModal}
          onClose={this.onCloseModal}
          size="small"
          className="modal-organic"
        >
          <Modal.Header>Log</Modal.Header>
          <Modal.Content>
            <TextArea
              className="organic-log"
              placeholder="Debug Log"
              disabled
              rows="18"
              value={log}
            />
          </Modal.Content>
        </Modal>
        {loadingAccounts && <Loader active size="big" />}
        {!loadingAccounts && (
          <table className="table-organic">
            <tr>
              <td className="col-selection">
                <Dropdown
                  placeholder="Ad Accounts"
                  search
                  selection
                  value={this.state.adAccountId}
                  options={accountOptions}
                  onChange={this.onAccountSelect}
                />
                <Button
                  basic
                  compact
                  loading={refreshAccountsLoading}
                  color="blue"
                  icon="refresh"
                  onClick={this.refreshAccounts}
                  style={{ marginLeft: '2%' }}
                />
                <Divider hidden />
                {this.state.showYearSelector ? (
                  <Dropdown
                    placeholder="Year"
                    search
                    selection
                    value={this.state.selectedYear}
                    options={years}
                    onChange={this.onYearSelect}
                  />
                ) : this.state.showYearLoader ? (
                  <Container>
                    <Loader inline className="active" />{' '}
                  </Container>
                ) : null}
                <Divider hidden />
                {this.state.showMonthSelector ? (
                  <Dropdown
                    placeholder="Month"
                    search
                    selection
                    options={filteredCampaigns}
                    value={this.state.selectedCampaigns}
                    onChange={this.onMonthSelect}
                  />
                ) : this.state.showMonthLoader ? (
                  <Container>
                    <Loader inline className="active" />{' '}
                  </Container>
                ) : null}
              </td>
              <td
                className="col-list"
                style={{ paddingLeft: '1%', width: '32%' }}
              >
                {this.state.doneLoading ? (
                  <OrganicPreviewList
                    organicList={this.state.organicList}
                    openAccordion={this.openAccordion}
                  />
                ) : null}
              </td>
              <td className="col-calendar">
                {this.state.doneLoading ? (
                  <div>
                    <div className="result-container">
                      {this.state.processing ? (
                        <div className="processing-container">
                          <span>
                            {' '}
                            <Loader inline className="active" />{' '}
                          </span>
                        </div>
                      ) : null}
                      {this.state.processingText}
                    </div>
                    <div>
                      <Grid verticalAlign="middle" textAlign="center">
                        <Grid.Row>
                          <Grid.Column width={2}>
                            <Button
                              onClick={() => this.prevMonth()}
                              icon="angle left"
                            />
                          </Grid.Column>
                          <Grid.Column width={12}>
                            <a
                              className="show-calendar-link"
                              onClick={this.showCalendar}
                            >
                              <div className="col-calendar">
                                <DayPicker
                                  className="fixed-calendar"
                                  month={calendarCurrentMonth}
                                  canChangeMonth={false}
                                  renderDay={(day) => this.renderDay(day, true)}
                                />
                              </div>
                            </a>
                          </Grid.Column>
                          <Grid.Column width={2}>
                            <Button
                              onClick={() => this.nextMonth()}
                              icon="angle right"
                            />
                          </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                          <Grid.Column width={16}>
                            <Dropdown
                              placeholder="Month"
                              search
                              selection
                              options={calendarMonth}
                              value={this.state.calendarSelectedMonth}
                              onChange={this.onCalendarMonthSelect}
                            />
                            <Button onClick={this.currentMonth}>
                              Selected Month
                            </Button>
                          </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                          <Grid.Column width={8}>
                            <div className="col-button">
                              <div className="button-schedule-posts">
                                <Button
                                  color="green"
                                  onClick={this.schedulePosts}
                                >
                                  Schedule
                                </Button>
                              </div>
                            </div>
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                    </div>
                  </div>
                ) : null}
              </td>
            </tr>
          </table>
        )}
        {!this.state.doneLoading && this.state.showAdsLoading ? (
          <Loader className="active" />
        ) : null}
        {!this.state.doneLoading ? null : (
          <div style={{ width: '100%', height: '100%' }}>
            <Grid columns={1} divided>
              <Grid.Row>
                <Grid.Column>
                  <strong>Expand all</strong>{' '}
                  <Checkbox
                    toggle
                    onChange={this.handleExpandAll}
                    checked={this.state.expandAll}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <Divider />
            <div className="category-tabs">
              {this.renderCampaignsTabs(campaignMonth)}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default OrganicSimplifier;



// WEBPACK FOOTER //
// ./src/screens/Organic/OrganicSimplifier.js